export default function hasComponent(name) {
	if (!name) {
		console.error('Empty component name');
		return false;
	}

	const component = name.replace(/(-?\w)(-?\w*)/g, (g0, g1, g2) => g1.replace(/-/, '').toUpperCase() + g2.replace(/-/, '').toLowerCase());
	const has = Boolean(this.$options.components[component]);

	if (has) {
		// console.debug(`Using component: ${name} (${component})`);
	} else {
		console.error(`There is no component with name: ${name} (${component})`);
	}

	return has;
}
